import React, {useContext} from "react";
import {SlideoutContext} from "../slideout-navigation/slideout-provider";
import {getUserAvatar} from "../../actions/environment";
import NavigationUser from "./navigation-user";
import {useAuthorization, useSiteConfiguration} from "../../selectors";
import {TooltipLink} from "./buttons/nav-buttons";
import {useLanguage} from "../configuration/configuration";
import {AppsIcon, CelebrationIcon, EventIcon, HomeIcon} from "./icons/nav-icons";

const NavigationSlideoutToggler = () => {
    const {toggle} = useContext(SlideoutContext);
    const {isAuthorized, principal} = useAuthorization();
    const {homePage, festivalsCalendarPage, spacesCalendarPage, eventsCalendarPage} = useSiteConfiguration();
    const Lang = useLanguage();

    const name = principal ? principal.firstname : 'Loading..';
    const avatar = principal ? getUserAvatar(principal) : 'Loading..';

    const handleOnToggle = (event) => {
        event.preventDefault();
        toggle();
    }

    return <div className='d-flex'>
            <TooltipLink className='nav-link box-aligned justify-content-md-between' to={homePage}>
                <HomeIcon big className='mr-2'/>
                <span className='nav-item-hide'>{Lang.nav.header.home}</span>
            </TooltipLink>
                                     
            <TooltipLink className='nav-link box-aligned justify-content-md-between' to={eventsCalendarPage}>
                <EventIcon big className='mr-2'/>
                <span className='nav-item-hide'>{Lang.nav.header.events.text}</span>
            </TooltipLink>

        <TooltipLink className='nav-link box-aligned justify-content-md-between' to={festivalsCalendarPage}>
            <CelebrationIcon big className='mr-1'/>
            <span className='nav-item-hide'>{Lang.nav.header.festivals.mobile}</span>
        </TooltipLink>

        <TooltipLink className='nav-link box-aligned justify-content-md-between' to={spacesCalendarPage}>
            <AppsIcon big className='mr-1'/>
            <span className='nav-item-hide'>{Lang.nav.header.spaces.mobile}</span>
        </TooltipLink>
        
            <button className="navbar-toggler" type="button" data-toggle="offcanvas-collapse">
                {isAuthorized && <NavigationUser avatar={avatar} name={name} to={`/${principal.username}/home`}/>}
                <span className="navbar-toggler-icon" onClick={handleOnToggle}/>
            </button>
        </div>
};

export default NavigationSlideoutToggler;